// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import './styles/libs/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import './assets/svg'
import VueClipboard from 'vue-clipboard2'
import VueCookies from 'vue-cookies'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import qs from 'qs'
import md5 from 'js-md5'
import pathUtils from './util/pathUtils'

Vue.config.productionTip = false

/* 兼容旧版 Popconfirm 事件名（新版 confirm -> 旧版 onConfirm） */
/* 需在 Vue.use(ElementUI) 之前添加 */
const Popconfirm = ElementUI.Popconfirm
if (Popconfirm && Popconfirm.methods && Popconfirm.methods.confirm) {
  const originalConfirm = Popconfirm.methods.confirm
  Popconfirm.methods.confirm = function () {
    this.$emit('onConfirm')
    originalConfirm.call(this)
  }
}
if (Popconfirm && Popconfirm.methods && Popconfirm.methods.cancel) {
  const originalCancel = Popconfirm.methods.cancel
  Popconfirm.methods.cancel = function () {
    this.$emit('onCancel')
    originalCancel.call(this)
  }
}

/* 引入element-ui，指定尺寸以及弹窗的默认z-index */
Vue.use(ElementUI, { size: 'small', zIndex: 3000 })
/* 引入复制功能 */
Vue.use(VueClipboard)
/* 引入cookie工具 */
Vue.use(VueCookies)

/**
 * 初始化
 */

/**
 * axios设置
 */
const $axios = axios.create({
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'text/html, */*',
    'X-Requested-With': 'XMLHttpRequest'
  }
})

$axios.interceptors.request.use(config => {
  let requestUrl = config.url
  if (requestUrl && requestUrl.startsWith('/')) {
    config.url = pathUtils.getContextPath(requestUrl)
  }
  return config
})

/* 支持全局事件 */
const bus = new Vue()
Vue.prototype.$bus = bus
/* 引入ajax请求方案 */
Vue.prototype.$ajax = function (config) {
  let promise
  if (pathUtils.isProtectedUrl(config.url)) {
    promise = new Promise((resolve, reject) => {
      store.dispatch('loadAuthorization').then(() => {
        // 令牌有效
        $axios(config).then(response => {
          resolve(response)
        }, err => {
          reject(err)
        })
      }, () => {
        // 令牌失效
        let redirectPath = pathUtils.getContextPath('/')
        if (redirectPath !== window.location.pathname) {
          window.location.href = redirectPath
        } else {
          router.push({ path: '/' })
        }
      })
    })
  } else {
    promise = $axios(config)
  }
  return promise
}
Vue.prototype.$qs = qs
Vue.prototype.$md5 = md5
Vue.prototype.$extend = function () {
  if (arguments.length > 0) {
    let target = {}
    for (let index = 0; index < arguments.length; index++) {
      let data = arguments[index]
      if (data) {
        for (let key in data) {
          target[key] = data[key]
        }
      }
    }
    return target
  } else {
    return null
  }
}
Vue.prototype.$contextPath = pathUtils.getContextPath

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
